import * as React from 'react'
import './styles.css'
import '../Overview/styles.css'
import { motion } from 'motion/react'
import { descriptionAnimation, titleAnimation } from '../../../constants/animation'
import { ReactComponent as Support } from '../../../assets/imgs/overview/support.svg'

const IntelligenceLayer = () => {
  return (
    <section className='intelligence-layer-section'>
      <div className='box'>
        <div className='intelligence-layer-grid'>
          <div className='intelligence-layer-copy'>
            <motion.h2
              className='intelligence-layer-title'
              initial='hidden'
              animate='visible'
              variants={titleAnimation}
            >
              Turn Disconnected Workforce Systems Into One Intelligence Layer
            </motion.h2>
            <motion.p
              className='intelligence-layer-text'
              initial='hidden'
              animate='visible'
              variants={descriptionAnimation}
            >
              Organizations already have workforce data across ATS, HRIS, LMS,
              CRM, resumes, and external systems — but it exists in silos.
            </motion.p>
            <motion.p
              className='intelligence-layer-text'
              initial='hidden'
              animate='visible'
              variants={descriptionAnimation}
            >
              <span className='intelligence-layer-trademark'>
                Pod Intelligence Core™
              </span>{' '}
              securely ingests, normalizes, and structures fragmented workforce
              data into a unified intelligence layer, transforming disconnected
              information into real-time visibility on skills, workforce
              distribution, and emerging capability gaps.
            </motion.p>
            <motion.p
              className='intelligence-layer-text'
              initial='hidden'
              animate='visible'
              variants={descriptionAnimation}
            >
              Rather than replacing existing enterprise infrastructure, Pod
              operates as an intelligence layer above your systems — enabling
              rapid deployment, minimal disruption, and immediate strategic
              value for enterprise and government organizations.
            </motion.p>
          </div>

          <motion.div
            className='intelligence-layer-visual overview-tile-container gradient-left relative-wrapper box-relative-gradient'
            initial='hidden'
            animate='visible'
            variants={descriptionAnimation}
          >
            <Support className='elements elements-frontal' />
            <div className='description-wrapper'>
              <div className='description-title'>Seamless Integration</div>
              <div className='description-subtitle'>
                Effortlessly connect Pod with your ATS, CRM, and HR systems.
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  )
}

export default IntelligenceLayer
